// JsFromRoutes CacheKey 4360bcf9d0319994f31b20411a1b5a6c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/packs"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/packs"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/packs/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/packs/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/:venue_slug/packs/:id"),
}
